<template>

  <div class="separated-date-time text-body06-regular">

    <div class="date-time-wrapper">
      <label class="date-time-label">{{ $t('message.pickUpDate') }}</label>
      <div class="date-time-row">
        <div class="separated-date-time-symbol" :data-target="targetDate" :data-toggle="targetDate">
          <img class="separated-date-icon" src="@/assets/icon/v3/date.svg" alt="cal">
        </div>
        <input
            type="text"
            :placeholder="datelabel"
            class="separated-date-input"
            :data-target="targetDate"
            ref="dateRef"
            readonly
        />
      </div>
    </div>

    <div class="date-time-wrapper">
      <label class="date-time-label">{{ $t('message.pickUpTime') }}</label>
      <div class="date-time-row-time">
        <div class="separated-date-time-symbol" :data-target="targetTime" :data-toggle="targetTime">
          <img class="separated-time-icon" src="@/assets/icon/v3/time.svg" alt="clock">
        </div>
        <input
            type="text"
            :placeholder="timelabel"
            class="separated-time-input"
            :data-target="targetTime"
            ref="timeRef"
            readonly
            @click="toggleDropdown"
            v-model="selectedTime"
        />
        <!-- Time Picker Dropdown -->
        <div v-if="showDropdown" class="time-picker-dropdown" ref="dropdown">
          <div class="time-section">
<!--            <label>{{ timeSectionLabels[0] }}</label>-->
            <div class="time-buttons">
              <b-button
                  v-for="(time, index) in availableTimesDay"
                  :key="index"
                  class="time-button"
                  variant="light"
                  @click="selectTime(time)"
                  :disabled="isBeforeEarliest(time)"
                  :class="{ 'custom-button': true, 'disabled-button': isBeforeEarliest(time) }"
              >
                {{ time }}
              </b-button>
            </div>
          </div>

          <div class="time-gap"></div>

          <div class="time-section">
<!--            <label>{{ timeSectionLabels[1] }}</label>-->
            <div class="time-buttons">
              <b-button
                  v-for="(time, index) in availableTimesNight"
                  :key="index"
                  class="time-button"
                  variant="light"
                  @click="selectTime(time)"
                  :disabled="isBeforeEarliest(time)"
                  :class="{ 'custom-button': true, 'disabled-button': isBeforeEarliest(time) }"
              >
                {{ time }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>


import {DateTime, Namespace, TempusDominus} from '@eonasdan/tempus-dominus';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);

export default {
  name: "DateTimeInputNativeSeparated",
  props: ["value", "datelabel", "timelabel", "id", "minDate", "maxDate", "location", "widgetType", "bookViewFilter"],
  computed: {

    idInternal: {
      get() {
        return this.id;
      },
    },
    targetTime: {
      get() {
        return "#" + this.idInternal + "time";
      },
    },
    targetDate: {
      get() {
        return "#" + this.idInternal + "date";
      },
    },
    internalValue: {
      get() {

        return this.value;
      },
      set(newValue) {

        this.$emit("input", newValue);
        this.$emit("update-date", newValue);
      },
    },
    localJustDate: {
      get() {
        return dayjs(this.value).format('YYYY-MM-DD');//2024-05-13 string
      }
    },
 /*   localLocation: {
      get() {
        return this.location;
      }
    }
*/
  },
  data() {
    return {
      pickerDate: null,
      pickerTime: null,
      disabledIntervals: [],

      showDropdown: false,
      selectedTime: null,
      availableTimes: [], // Will store the generated time options
      timeslots: [
        { startTime: "0000", endTime: "2359" },

      ],
      availableTimesDay:[],
      availableTimesNight:[],
      timeSectionLabels:[],
      earliestTime: "",//format "07:30
      earliestTimeInFullFormat:null,//format example Fri Mar 07 2025 09:45:13 GMT+0100 (Central European Standard Time)
    };
  },
  mounted() {
    this.initializeDatePicker();
    setTimeout(()=>{

      this.initializeTime(this.internalValue);
    },50)


/*    this.updateDisabledIntervals();*/
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    if (this.pickerDate) {
      this.pickerDate.dispose();
    }
    if (this.pickerTime) {
      this.pickerTime.dispose();
    }
  },
  watch: {

    timeslots: {
      handler(newVal, oldVal) {

        this.generateAvailableTimes();
      },
      deep: true, // This ensures Vue detects changes inside the array
      immediate: true, // (Optional) Runs the handler immediately with the initial value
    },

    showDropdown:function(newVal){
      if(newVal){
        this.handleDateTimePickerFocus("show");
      }else{
        this.handleDateTimePickerFocus("hide");
      }

    },
    minDate: function (newVal, oldVal) {
      if (!this.pickerDate && !this.pickerTime) return;
      this.pickerDate.updateOptions({
        restrictions: {
          minDate: newVal
        },
      });
/*console.log(">>>> minDate/time/nowDateTime is ",newVal);//format example Fri Mar 07 2025 09:45:13 GMT+0100 (Central European Standard Time)*/
      this.earliestTimeInFullFormat = newVal;
      this.earliestTime = dayjs(newVal).format("HH:mm");
    },
    maxDate: function (newVal, oldVal) {

      if (!this.pickerDate && !this.pickerTime) return;
      this.pickerDate.updateOptions({
        restrictions: {
          maxDate: newVal
        },
      });
    },
    value: function (newVal, oldVal) {
      if (!this.pickerDate && !this.pickerTime) return;

      if(newVal !== oldVal){
          this.updateDateTimePickersAndOpeningHours(newVal, oldVal)
      }
    },

    location: {
      handler(newVal,oldVal) {
        if (newVal !== oldVal) {

          this.updatePickUpTimeBasedOnLocationAndDate(newVal, this.localJustDate);
          this.getHolidaysClosedForBusiness(newVal);
          this.getWeekdayClosedForBusiness(newVal);
        }
   /*     this.updateDisabledIntervals();*/
      },
      immediate: true,
    },

    localJustDate: function (newVal, oldVal) {
      if (this.widgetType === 0 || this.widgetType === 1) {
        if (newVal !== oldVal) { //newVal is 2029-07-24 string

          this.updatePickUpTimeBasedOnLocationAndDate(this.location, newVal);//newVal is string 2029-06-13
        }
      }
    }
  },
  methods: {

    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    selectTime(time) {

      this.selectedTime = time;//format "12:30"
      const dateTime = this.internalValue;//GMT format
      const date = dayjs(dateTime).format('YYYY-MM-DD');
      const dateTimeString = `${date}T${time}:00`; // ISO 8601 format

      const newDateTime = new Date(dateTimeString);

      this.internalValue = newDateTime;
      this.showDropdown = false;
    },

    generateAvailableTimes() {//input parameters are timeslots
      const timesDay = [];
      const timesNight = [];

      // Handle the case where the timeslots array contains two identical objects
      if (
          this.timeslots.length === 2 &&
          this.timeslots[0].startTime === this.timeslots[1].startTime &&
          this.timeslots[0].endTime === this.timeslots[1].endTime
      ) {
        this.timeslots = [this.timeslots[0]];
      }

      // Check for special case where startTime and endTime are both "0000"
      if (this.timeslots.length === 1 && this.timeslots[0].startTime === "0000" && this.timeslots[0].endTime === "0000") {
        this.timeslots = [{ startTime: "0000", endTime: "2359" }];
      }


      this.timeslots.forEach((slot, index) => {
        const start = this.formatTime(slot.startTime);
        let end = this.formatTime(slot.endTime);
        // Handle the case where startTime and endTime are the same (e.g., { startTime: "2300", endTime: "2300" })
        if (start === end) {
          // If it's the first timeslot, push to timesDay, if it's the second timeslot, push to timesNight
          if (index === 0) {
            timesDay.push(start);
          } else {
            timesNight.push(start);
          }
        } else {
          let currentTime = start;

          // Split into two sections if there are two timeslots
          while (currentTime <= end) {
            if (index === 0) {
              timesDay.push(currentTime);
            } else {
              timesNight.push(currentTime);
            }
            currentTime = this.addMinutes(currentTime, 30);
            if(currentTime == "24:00"){
              currentTime = "23:59"
            }
          }
        }
      });

      this.availableTimesDay = timesDay;
      this.availableTimesNight = timesNight;

      // Set the section labels dynamically based on timeslots
      this.timeSectionLabels = [
        `${this.formatTime(this.timeslots[0].startTime)} - ${this.formatTime(this.timeslots[0].endTime)}`,
        `${this.formatTime(this.timeslots[1]?.startTime || "")} - ${this.formatTime(this.timeslots[1]?.endTime || "")}`
      ];
    },


    // level :0
    formatTime(timeStr) {
      return `${timeStr.slice(0, 2)}:${timeStr.slice(2)}`;
    },
    // level :0
    addMinutes(time, minutesToAdd) {
      let [hours, minutes] = time.split(":").map(Number);
      minutes += minutesToAdd;
      if (minutes >= 60) {
        hours += 1;
        minutes -= 60;
      }
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
    },


    handleDateTimePickerFocus(event) {

      const height = document.body.scrollHeight;
      let calculatedHeight = height;
      if(event =="show"){
        calculatedHeight = height + calculatedHeight;//double the height
      }
      if(event == "hide"){
        calculatedHeight = height;
      }

      // Post the updated height to the parent
      window.parent.postMessage({ iframeHeight: calculatedHeight }, '*');

    },

    initializeTime(date){

      let currentTime = dayjs(date);

      let hour = currentTime.hour();
      let minute = currentTime.minute();


      if(!(hour === 23 && minute === 59)){
        if (minute > 30) {
          hour += 1;
          minute = 0;
        }else if(0 < minute && minute <= 30) {
          minute = 30;
        } else if(minute === 0){

          minute = 0;
        }
      }
      const nextHalfHour = dayjs().hour(hour).minute(minute).format("HH:mm");

      this.selectedTime = nextHalfHour;

    },
    initializeDatePicker() {

      this.pickerDate = new TempusDominus(this.$refs.dateRef, {
        useCurrent: true,
        display: {
          viewMode: 'calendar',
          components: {
            clock: false,
            hours: false,
            minutes: false,
            seconds: false,
          },
        },
        restrictions: {
          minDate: this.minDate || new Date(),
          disabledDates: [],
        },
        localization: {
          format: "dd/MM/yyyy",
          startOfTheWeek: 1,
          locale: "en",
        },
      });

    this.$refs.dateRef.addEventListener(Namespace.events.change, (e) => {

        if (e.detail.date) {
           this.internalValue = e.detail.date;
         }
    });

      if (this.internalValue) {

        this.pickerDate.dates.setValue(DateTime.convert(this.internalValue));
      }



      this.pickerDate.subscribe(Namespace.events.show, () => {

        this.handleDateTimePickerFocus("show"); // Trigger iframe resize
      });

      this.pickerDate.subscribe(Namespace.events.hide, () => {

        this.handleDateTimePickerFocus("hide"); // Trigger iframe resize
      });
    },
    handleClickOutside(event) {
      // Check if click is outside the dropdown and input field
      if (
          this.showDropdown &&
          this.$refs.dropdown &&
          !this.$refs.dropdown.contains(event.target) &&
          !this.$refs.timeRef.contains(event.target)
      ) {
        this.showDropdown = false;
      }
    },
    // Check if a given time (formatted as "HH:mm") is before the earliestTime
    isBeforeEarliest(time) {

      //compare if the chosen date is after today's now date, if it is, return false

      const chosenDate= dayjs(this.internalValue).startOf("day");

      const earliestDate= dayjs(this.earliestTimeInFullFormat).startOf("day");

      if(chosenDate.isAfter(earliestDate)) {
        return false;
      } else{
          if (!this.earliestTime) return false;

          const [eHour, eMinute] = this.earliestTime.split(":").map(Number);
          const earliestMinutes = eHour * 60 + eMinute;
          const [tHour, tMinute] = time.split(":").map(Number);
          const timeMinutes = tHour * 60 + tMinute;
          return timeMinutes < earliestMinutes;
      }
    },

    getTheWeekdayFromDate(datestring) {

      const dayOfWeek = dayjs(datestring).day();
      const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const weekdayName = weekdays[dayOfWeek];
      return weekdayName;
    },

    parseTimeString(timeString) {
      // Assuming the times are in the format HHmm
      return dayjs().hour(parseInt(timeString.substring(0, 2), 10)).minute(parseInt(timeString.substring(2, 4), 10));
    },
    calculateStartTimeForCurrentDate(starttimeStr, endtimeStr) {

      const pickuptimeStr = dayjs(this.minDate).format("HHmm");


      const starttimeFromStr = this.parseTimeString(starttimeStr);
      const endtimeFromStr = this.parseTimeString(endtimeStr);
      const pikuptimeFromStr = this.parseTimeString(pickuptimeStr);
      const isBetweenTime = pikuptimeFromStr.isAfter(starttimeFromStr) && pikuptimeFromStr.isBefore(endtimeFromStr);
      const isAfter = pikuptimeFromStr.isAfter(endtimeFromStr);
      const isBefore = pikuptimeFromStr.isBefore(starttimeFromStr);
      if (isBefore) {
        return starttimeStr;
      }
      if (isBetweenTime) {
        return pickuptimeStr;
      }
      if (isAfter) {
        return endtimeStr;
      } else {
        return starttimeStr;
      }
    },
     getNextHalfHour(time) {
       let parsedTime = dayjs(time, 'HH:mm');
       const currentHours = parsedTime.hour();
       const currentMinutes = parsedTime.minute();
       if (currentMinutes === 30) {
       } else if (currentMinutes < 30) {
         parsedTime = parsedTime.minute(30).second(0);
       } else {
         parsedTime = parsedTime.add(1, 'hour').minute(0).second(0);
       }
       if (currentHours === 23 && currentMinutes >= 30) {
         parsedTime = parsedTime.hour(23).minute(59).second(0);
       }
       return parsedTime.format('HH:mm');
     },
    updatePickUpTimeBasedOnLocationAndDate(pickUpLocation, justdate) {

      let startTimeForCurrentDate = '';

      const currentDateFormatted = justdate;//2024-06-16
      const weekday = this.getTheWeekdayFromDate(currentDateFormatted);

      if (pickUpLocation) {
        const openingTimes = pickUpLocation?.openingTimes;
        const holidays = pickUpLocation?.holidays;

        if (!openingTimes?.length && !holidays?.length) {
          startTimeForCurrentDate = "0800";
        } else {
          if (this.widgetType === 0) {
            const openingDay = openingTimes?.filter(ot => (ot.timeType === this.widgetType && ot.description === weekday));
            const matchedOpeningDay = openingDay[0];

            if (matchedOpeningDay?.startTime[0] === '0001' && matchedOpeningDay?.endTime[0] === "2359") {//means this day is closed for business
              //handle the scenario that all sundays for example are closed for business

              const nextWeekday = dayjs(currentDateFormatted).add(1, 'day').format('YYYY-MM-DD');

              setTimeout(() => {
                this.updatePickUpTimeBasedOnLocationAndDate(pickUpLocation, nextWeekday);
              }, 0);

            } else {
              this.timeslots = [
                  {startTime:matchedOpeningDay.startTime[0],endTime:matchedOpeningDay.endTime[0]},
                  {startTime:matchedOpeningDay.startTime[1],endTime:matchedOpeningDay.endTime[1]}
              ];
              const today = new Date();
              const todayDate= today.toISOString().split("T")[0];//format as 2025-02-25
              const todayHour = today.getHours().toString().padStart(2, '0');
              const todayMinute = today.getMinutes().toString().padStart(2, '0');
              const nowTime = `${todayHour}${todayMinute}`;
///
              let starttimeStr = '';
              let endtimeStr = '';
              if (matchedOpeningDay?.endTime[0] == "0000") {
                endtimeStr = "2359";
              } else {
                starttimeStr = matchedOpeningDay?.startTime[0];
                endtimeStr = matchedOpeningDay?.endTime[0];
              }

              const matchedOpeningDayStartTime = starttimeStr;
              const matchedOpeningDayEndTime = endtimeStr

              //is the chosen date today?
              if(currentDateFormatted === todayDate){
                if((parseInt(nowTime)-parseInt(matchedOpeningDayStartTime))>=0 && (parseInt(nowTime)-parseInt(matchedOpeningDayEndTime))<=0 ){
                  startTimeForCurrentDate = nowTime;
                }else if((parseInt(nowTime)-parseInt(matchedOpeningDayStartTime))<0){
                  startTimeForCurrentDate = matchedOpeningDayStartTime;
                } else if((parseInt(nowTime)-parseInt(matchedOpeningDayEndTime))>0){
                  startTimeForCurrentDate = matchedOpeningDayEndTime;
                }

              }else{
                startTimeForCurrentDate =  matchedOpeningDayStartTime;
              }
            }

            if (holidays?.length) {
              holidays?.filter(holiday => holiday.timeType === this.widgetType).map(holiday => {
                const dateFormated = dayjs(holiday.date).format("YYYY-MM-DD");//e.g. 2024-06-18
                if (dateFormated === currentDateFormatted) {

                  //when this holiday is set to 0001-2359, means this date is closed for business, then it should not show this any time in this day, show next days start time
                  if (holiday.startTime[0] === '0001' && holiday.endTime[0] === "2359") {
                    const nextDay = dayjs(holiday.date).add(1, 'day').format("YYYY-MM-DD");


                    // Delay the recursive function call using setTimeout
                    setTimeout(() => {
                      this.updatePickUpTimeBasedOnLocationAndDate(pickUpLocation, nextDay);
                    }, 50);

                    return;
                  } else {
                    this.timeslots = [{startTime:holiday.startTime[0],endTime:holiday.endTime[0]}];
                    startTimeForCurrentDate = holiday.startTime[0];
                  }

                }
              })
            }
            if (startTimeForCurrentDate) {
              const hourString = startTimeForCurrentDate?.substring(0, 2);
              const minuteString = startTimeForCurrentDate?.substring(2, 4);
              this.earliestTime = `${hourString}:${minuteString}`;

              const [hour, minute] = this.earliestTime.split(":").map(Number);
              const roundedMinutes = minute >30 ? 0 : (minute === 0? 0: 30);
              const adjustedHour = minute > 30 ? hour + 1 : hour;

              this.selectedTime = `${String(adjustedHour).padStart(2, "0")}:${String(roundedMinutes).padStart(2, "0")}`;
              const calculatedStartingDateTime = (new Date(currentDateFormatted));
              calculatedStartingDateTime.setHours(adjustedHour);
              calculatedStartingDateTime.setMinutes(roundedMinutes);

              this.internalValue =  calculatedStartingDateTime;

         /*     setTimeout(()=>{
                console.log("selectedTime this.internalValue:",this.internalValue);
                }, 50)*/


            }

          }
          else if (this.widgetType === 1) {

            const openingDay = openingTimes?.filter(ot => (ot.timeType === this.widgetType && ot.description === weekday));
            const matchedOpeningDay = openingDay[0];

            if (matchedOpeningDay?.startTime[1] === '0001' && matchedOpeningDay?.endTime[1] === "2359") {
              //handle the scenario that all sundays for example are closed for business

              const nextWeekday = dayjs(currentDateFormatted).add(1, 'day').format('YYYY-MM-DD');

              setTimeout(() => {
                this.updatePickUpTimeBasedOnLocationAndDate(pickUpLocation, nextWeekday);
              }, 0);

            }
            else {
              this.timeslots =[
                  {startTime:matchedOpeningDay.startTime[0],endTime:matchedOpeningDay.endTime[0]},
                  {startTime:matchedOpeningDay.startTime[1],endTime:matchedOpeningDay.endTime[1]}
              ];



              let starttimeStr = '';
              let endtimeStr = '';

              if (matchedOpeningDay?.endTime[1] == "0000") {
                endtimeStr = "2359";
              }  else {
                endtimeStr = matchedOpeningDay?.endTime[1];
              }

              startTimeForCurrentDate = endtimeStr;


              // get earliest time for today

                const today = new Date();
                const todayDate = today.toISOString().split("T")[0];//format as 2025-02-25
                const todayHour = today.getHours().toString().padStart(2, '0');
                const todayMinute = today.getMinutes().toString().padStart(2, '0');
                const nowTime = `${todayHour}${todayMinute}`;
///
                let starttimeStr0 = '';
                let endtimeStr0 = '';
                if (matchedOpeningDay?.endTime[0] == "0000") {
                  endtimeStr0 = "2359";
                } else {
                  starttimeStr0 = matchedOpeningDay?.startTime[0];
                  endtimeStr0 = matchedOpeningDay?.endTime[0];
                }

                let starttimeStr1 = '';
                let endtimeStr1 = '';
                if (matchedOpeningDay?.endTime[1] == "0000") {
                  endtimeStr1 = "2359";
                } else {
                  starttimeStr1 = matchedOpeningDay?.startTime[1];
                  endtimeStr1 = matchedOpeningDay?.endTime[1];
                }
                let earliestTime = '';
                const matchedOpeningDayStartTime = starttimeStr0;
                const matchedOpeningDayEndTime = endtimeStr0;
                //is the chosen date today?
                if (currentDateFormatted === todayDate) {

                  /*if ((parseInt(nowTime) - parseInt(matchedOpeningDayStartTime)) > 0 && (parseInt(nowTime) - parseInt(matchedOpeningDayEndTime)) < 0) {
                    earliestTime = nowTime;

                  } else if ((parseInt(nowTime) - parseInt(matchedOpeningDayStartTime)) < 0) {
                    earliestTime = matchedOpeningDayStartTime;
                  } else if ((parseInt(nowTime) - parseInt(matchedOpeningDayEndTime)) > 0) {
                    if ((parseInt(nowTime) - parseInt(starttimeStr1)) < 0) {
                      earliestTime = matchedOpeningDayEndTime;
                    } else if ((parseInt(nowTime) - parseInt(starttimeStr1)) > 0 && (parseInt(nowTime) - parseInt(endtimeStr1)) < 0) {
                      earliestTime = nowTime;
                    } else if ((parseInt(nowTime) - parseInt(endtimeStr1)) >= 0) {
                      earliestTime = endtimeStr1;
                    }
                  }*/

                  earliestTime = this.getNextHalfHour(this.minDate);
                } else {
                 const earliestTime1 = matchedOpeningDayStartTime;
                  earliestTime = earliestTime1.slice(0, 2) + ":" + earliestTime1.slice(2);
                }

                this.earliestTime = earliestTime;
            }

            if (holidays?.length) {
              holidays?.filter(holiday => holiday.timeType === this.widgetType).map(holiday => {
                const dateFormated = dayjs(holiday.date).format("YYYY-MM-DD");//e.g. 2024-06-18
                if (dateFormated === currentDateFormatted) {
                  //when this holiday is set to 0001-2359, means this date is closed for business, then it should not show this any time in this day, show next days start time
                  if (holiday.startTime[0] === '0001' && holiday.endTime[0] === "2359") {
                    const nextDay = dayjs(holiday.date).add(1, 'day').format("YYYY-MM-DD");


                    // Delay the recursive function call using setTimeout
                    setTimeout(() => {
                      this.updatePickUpTimeBasedOnLocationAndDate(pickUpLocation, nextDay);
                    }, 50);

                    return;
                  }
                  else {
                    this.timeslots =[{startTime:holiday.startTime[0],endTime:holiday.endTime[0]}];
                    //startTimeForCurrentDate = holiday.startTime[0];
                    let startTimeStr = '';
                    let endTimeStr = '';

                    if (holiday.endTime[0] == "0000") {
                      endTimeStr = "2359";
                    } else {
                      startTimeStr = holiday.startTime[0];
                      endTimeStr = holiday.endTime[0];
                    }

                    /*   startTimeForCurrentDate = this.calculateStartTimeForCurrentDate(startTimeStr, endTimeStr);*/
                    startTimeForCurrentDate = endTimeStr;

                  }

                }
              })
            }
            if (startTimeForCurrentDate) {
              const hourString = startTimeForCurrentDate?.substring(0, 2);
              const minuteString = startTimeForCurrentDate?.substring(2, 4);

              const newHours = parseInt(hourString);
              const newMinutes = parseInt(minuteString);
              let calculatedStartingDateTime = (new Date(currentDateFormatted));
              calculatedStartingDateTime.setHours(newHours);
              calculatedStartingDateTime.setMinutes(newMinutes);

              let selectedTime = `${hourString}:${minuteString}`;
              if(selectedTime === "24:00"){
                selectedTime = "23:59"
              }
              this.selectedTime = selectedTime;

              this.internalValue = calculatedStartingDateTime;
      /*        setTimeout(()=>{
                console.log("selectedTime this.internalValue 111:",this.internalValue);
              }, 50)
*/
            }

          }
        }
      }
    },
    setTimeToBoundaryIfNotInsideValidPeriod(newVal) {

      const disabledIntervals = this.disabledIntervals;
      const newtime = newVal;
      for (let i = 0; i < disabledIntervals.length; i++) {
        const interval = disabledIntervals[i];
        const from = interval.from;
        const to = interval.to;


        if (dayjs(newtime).isBetween(from, to, null, '()')) {

          if (i === 0) {

            return interval.to
          } else {

            return interval.from
          }

        }
        /*   else {
             console.log("come here 4 not between false i is:", i)
           }*/
      }
      return newVal;
    },
    updateDateTimePickersAndOpeningHours(newVal, oldVal) {

      const format = "ddd MMM DD YYYY HH:mm:ss [GMT]Z [(]zzzz[)]";
      const dateNew = dayjs(newVal);
      const dateOld = dayjs(oldVal);

      const dateOnlyNew = dateNew.format("YYYY-MM-DD");
      const dateOnlyOld = dateOld.format("YYYY-MM-DD");
      const timeOnlyNew = dateNew.format("HH:mm:ss");
      const timeOnlyOld = dateOld.format("HH:mm:ss");

      const dateChanged = dateOnlyNew !== dateOnlyOld;
      const timeChanged = timeOnlyNew !== timeOnlyOld;
      if (dateChanged && timeChanged) {

        this.pickerDate.dates.setValue(DateTime.convert(newVal));
/*
        this.pickerTime.dates.setValue(DateTime.convert(newVal));
        this.updateDisabledIntervals();*/
      } else if (dateChanged) {

        this.pickerDate.dates.setValue(DateTime.convert(newVal));
  /*      this.updateDisabledIntervals();*/
      } else if (timeChanged) {
/*

        this.pickerTime.dates.setValue(DateTime.convert(newVal));


        const newTime = this.setTimeToBoundaryIfNotInsideValidPeriod(newVal);
        this.pickerTime.dates.setValue(DateTime.convert(newTime));
*/

        const time = timeOnlyNew.substring(0, 5);//change it from 12:30:00 to 12:30
        this.selectedTime = time;

      } else {
        console.log("date and time is not changed!")
      }
    },


    isSameDay: function (date1, date2) {
      return date1.getFullYear() === date2.getFullYear() &&
          date1.getMonth() === date2.getMonth() &&
          date1.getDate() === date2.getDate();
    },
    whichWeekDay: function (date) {

      const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      return weekdays[date.getDay()];// date is new Date()format

    },


    // when for a certain location, the holidays array is not empty, and for a certain date the startTime[0] === "0001" and endTime[0] === "2359",
    // it means this holiday is closed for business, then add this date to disabledDates array in tempus
    getHolidaysClosedForBusiness(location) {

      const holidays = location?.holidays;
      let datesClosedForBusiness = {};
      if (holidays?.length > 0) {
        holidays?.map((holiday) => {
          if (holiday.startTime[0] === "0001" && holiday.endTime[0] === "2359") {
            if (!datesClosedForBusiness[holiday.timeType]) {
              datesClosedForBusiness[holiday.timeType] = [];
            }
            const date = dayjs(holiday.date).toDate();//utc string to GMT+2
            datesClosedForBusiness[holiday.timeType].push(date);
          }
        })
      }

      if (datesClosedForBusiness[this.widgetType]) {
        this.pickerDate.updateOptions({
          restrictions: {
            disabledDates: datesClosedForBusiness[this.widgetType]
          }
        });
      }
    },

    getWeekDayNumber(weekday) {
      const weekdayMapping = {
        'sunday': 0,
        'monday': 1,
        'tuesday': 2,
        'wednesday': 3,
        'thursday': 4,
        'friday': 5,
        'saturday': 6
      };
      const day = weekday.toLowerCase();
      return weekdayMapping[day];

    },

    getWeekdayClosedForBusiness(location) {

      const openingTimes = location?.openingTimes;
      let weekdayClosedForBusiness = {};
      if (openingTimes?.length > 0) {
        openingTimes.map((ot) => {
          if (ot.startTime[0] === "0001" && ot.endTime[0] === "2359") {
            if (!weekdayClosedForBusiness[ot.timeType]) {
              weekdayClosedForBusiness[ot.timeType] = [];
            }
            const weekday = ot.description;// e.g. Sunday
            const weekdayNumber = this.getWeekDayNumber(weekday);
            weekdayClosedForBusiness[ot.timeType].push(weekdayNumber);
          }
        })
      }
      if (weekdayClosedForBusiness[this.widgetType]) {
        this.pickerDate.updateOptions({
          restrictions: {
            daysOfWeekDisabled: weekdayClosedForBusiness[this.widgetType]
          }
        });
      }

    },

    getOneDisabledInterval(startTime, endTime) {

      const startHour = parseInt(startTime.substring(0, 2));
      const startMinute = parseInt(startTime.substring(startTime.length - 2));

      const endHour = parseInt(endTime.substring(0, 2));
      const endMinute = parseInt(endTime.substring(endTime.length - 2));
      let fromTime, toTime;
      if (startTime === endTime) {
        fromTime = dayjs(this.value).set('hour', startHour).set('minute', startMinute).subtract(5, 'minute').toDate();
        toTime = dayjs(this.value).set('hour', endHour).set('minute', endMinute).add(5, 'minute').toDate();
      } else {
        fromTime = dayjs(this.value).set('hour', startHour).set('minute', startMinute).toDate();
        toTime = dayjs(this.value).set('hour', endHour).set('minute', endMinute).toDate();
      }

      const result = {fromTime, toTime};
      return result;
      /* }*/
    },
    getIntervalsArray(firstValidIntervals, secondValidIntervals) {
      const midnightAm = dayjs(this.value).set('hour', 0 - 1).set('minute', 0).toDate();
      const midnightPm = dayjs(this.value).set('hour', 24).set('minute', 0).toDate();
      const disabledIntervals = [];
      let disabledInterval1 = {};
      let disabledInterval2 = {};
      let disabledInterval3 = {};
      const beforefromtime1 = dayjs(firstValidIntervals.fromTime).subtract(1, 'minute');
      const formatBeforefromtime1 = beforefromtime1.toDate();
      const beforefromtime2 = dayjs(secondValidIntervals.fromTime).subtract(1, 'minute');
      const formatBeforefromtime2 = beforefromtime2.toDate();
      disabledInterval1 = {from: midnightAm, to: formatBeforefromtime1};
      disabledInterval2 = {from: firstValidIntervals.toTime, to: formatBeforefromtime2};
      disabledInterval3 = {from: secondValidIntervals.toTime, to: midnightPm};

      const firstPeriodIsAPoint = dayjs(firstValidIntervals.fromTime).isSame(dayjs(firstValidIntervals.toTime))
      const secondPeriodIsAPoint = dayjs(secondValidIntervals.fromTime).isSame(dayjs(secondValidIntervals.toTime))

      if (!firstPeriodIsAPoint && secondPeriodIsAPoint) {// todo needs test
        disabledInterval1 = {from: midnightAm, to: firstValidIntervals.fromTime};
        disabledInterval2 = {
          from: firstValidIntervals.toTime,
          to: dayjs(secondValidIntervals.fromTime).subtract(5, 'minute').toDate()
        };
        disabledInterval3 = {from: dayjs(secondValidIntervals.toTime).add(5, 'minute').toDate(), to: midnightPm};
      }
      if (firstPeriodIsAPoint && !secondPeriodIsAPoint) {// todo needs test
        disabledInterval1 = {from: midnightAm, to: dayjs(firstValidIntervals.fromTime).subtract(5, 'minute').toDate()};
        disabledInterval2 = {
          from: dayjs(firstValidIntervals.toTime).add(5, 'minute').toDate(),
          to: secondValidIntervals.fromTime
        };
        disabledInterval3 = {from: secondValidIntervals.toTime, to: midnightPm};
      }
      if (firstPeriodIsAPoint && secondPeriodIsAPoint) {// todo needs test
        disabledInterval1 = {from: midnightAm, to: dayjs(firstValidIntervals.fromTime).subtract(5, 'minute').toDate()};
        disabledInterval2 = {
          from: dayjs(firstValidIntervals.toTime).add(5, 'minute').toDate(),
          to: dayjs(secondValidIntervals.fromTime).subtract(5, 'minute').toDate()
        };
        disabledInterval3 = {from: dayjs(secondValidIntervals.toTime).add(5, 'minute').toDate(), to: midnightPm};
      }
      disabledIntervals.push(disabledInterval1)
      disabledIntervals.push(disabledInterval2)
      disabledIntervals.push(disabledInterval3)
      return disabledIntervals

    },
    getDisabledIntervalFraValidIntervals(validIntervals) {
      //validIntervals:[{startTime: "0800", endTime: "1600"},{startTime: "1800", endTime: "2000"}]
      const midnightAm = dayjs(this.value).set('hour', 0 - 1).set('minute', 0).toDate();
      const midnightPm = dayjs(this.value).set('hour', 24).set('minute', 0).toDate();


      if (validIntervals.length == 0) {
        const disabledIntervals = [];
        const timePoint = dayjs(this.value).set('hour', 0).set('minute', 3).toDate(); //could be any time, just need to disable time selection
        const disabledInterval1 = {from: midnightAm, to: timePoint};
        const disabledInterval2 = {from: timePoint, to: midnightPm};
        disabledIntervals.push(disabledInterval1);
        disabledIntervals.push(disabledInterval2);

        return disabledIntervals

      }
      if (validIntervals.length == 1) {


        const disabledIntervals = [];
        const startTime = validIntervals[0].startTime;
        const endTime = validIntervals[0].endTime;

        const result = this.getOneDisabledInterval(startTime, endTime)
        const fromTime = result.fromTime;
        const toTime = result.toTime;

        const beforefromtime = dayjs(fromTime).subtract(1, 'minute');
        const formatBeforefromtime = beforefromtime.toDate();

        const disabledInterval1 = {from: midnightAm, to: formatBeforefromtime};
        const disabledInterval2 = {from: toTime, to: midnightPm};
        disabledIntervals.push(disabledInterval1);
        disabledIntervals.push(disabledInterval2);

        return disabledIntervals
      }

      // handle case where there are 2 validintervals
      if (validIntervals.length == 2) {

        const startTime0 = validIntervals[0].startTime
        const endTime0 = validIntervals[0].endTime


        const startTime1 = validIntervals[1].startTime
        const endTime1 = validIntervals[1].endTime

        const firstStartTime = dayjs(startTime0, 'HHmm')
        const firstEndTime = dayjs(endTime0, 'HHmm')

        const secondStartTime = dayjs(startTime1, 'HHmm')
        const secondEndTime = dayjs(endTime1, 'HHmm')

        if (firstEndTime.isBefore(secondStartTime)) {

          const firstValidIntervals = this.getOneDisabledInterval(startTime0, endTime0)
          const secondValidIntervals = this.getOneDisabledInterval(startTime1, endTime1)
          const disabledIntervals = this.getIntervalsArray(firstValidIntervals, secondValidIntervals)
          return disabledIntervals
        }
        if (secondEndTime.isBefore(firstStartTime)) {

          const firstValidIntervals = this.getOneDisabledInterval(startTime1, endTime1)
          const secondValidIntervals = this.getOneDisabledInterval(startTime0, endTime0)
          return this.getIntervalsArray(firstValidIntervals, secondValidIntervals)
        } else {// otherwise, ignore the second period
          const startTime = validIntervals[0].startTime
          const endTime = validIntervals[0].endTime
          const disabledIntervals = [];
          const {fromTime, toTime} = this.getOneDisabledInterval(startTime, endTime)
          const beforefromtime = dayjs(fromTime).subtract(1, 'minute');
          const formatBeforefromtime = beforefromtime.toDate();
          const disabledInterval1 = {from: midnightAm, to: formatBeforefromtime};
          const disabledInterval2 = {from: toTime, to: midnightPm};
          disabledIntervals.push(disabledInterval1)
          disabledIntervals.push(disabledInterval2)
          return disabledIntervals

        }
      }


    },


    enrichEnabledIntervalsBasedOnOpeningsTimes(openingTimes) {

      return openingTimes?.map(openingTime => {
            const startTimeArray = openingTime?.startTime;
            const endTimeArray = openingTime?.endTime;

            let enabledIntervals = [];//[{startTime: "0800", endTime: "1600"},{startTime: "1800", endTime: "2200"}]

            if (!startTimeArray?.length || !endTimeArray?.length) {
              enabledIntervals = [{startTime: "0730", endTime: "1700"}];
            } else {

              const count = Math.min(startTimeArray.length, endTimeArray.length);
              for (let index = 0; index < count; index++) {
                enabledIntervals.push({startTime: startTimeArray[index], endTime: endTimeArray[index]});
              }
            }


            // handling edge cases, specially related to midnight 0000:
            enabledIntervals = enabledIntervals.filter(interval => !(interval.startTime == "2359" && interval.endTime == "0000"));
            enabledIntervals = enabledIntervals.filter(interval => !(interval.startTime == "0000" && interval.endTime == "2359"));
            enabledIntervals = enabledIntervals.filter(interval => !(interval.startTime == "0001" && interval.endTime == "2359"));

            if (enabledIntervals.length === 2 && enabledIntervals[0].startTime === "0000" && enabledIntervals[0].endTime === "0000" &&
                enabledIntervals[1].startTime === "0000" && enabledIntervals[1].endTime === "0000") {
              enabledIntervals = [{startTime: "0005", endTime: "2355"}];
            } else if (enabledIntervals.length === 1 && enabledIntervals[0].startTime === "0000" && enabledIntervals[0].endTime === "0000") {
              enabledIntervals = [{startTime: "0005", endTime: "2355"}];
            } else if (enabledIntervals.length === 2) {
              enabledIntervals = enabledIntervals.filter(interval => !(interval.startTime == "0000" && interval.endTime == "0000"));
              if (enabledIntervals[0] === enabledIntervals[1]) {
                enabledIntervals = enabledIntervals[0];
              }
            }


            //assume there are max two periods in the enabled intervals
            let validIntervals = [];
            if (enabledIntervals.length === 1) {

              //handling edge cases:
              if (enabledIntervals[0].startTime !== '0000' && enabledIntervals[0].endTime === '0000') {
                enabledIntervals[0].endTime = '2355';
              }
              if (enabledIntervals[0].startTime == '0000' && enabledIntervals[0].endTime !== '0000') {
                enabledIntervals[0].startTime = '0005';

              }

              validIntervals = enabledIntervals;

            } else if (enabledIntervals.length > 1) {

              const firstInterval = enabledIntervals[0];
              const secondInterval = enabledIntervals[1];
              const firstStartTime = dayjs(firstInterval.startTime, 'HHmm');
              const firstEndTime = dayjs(firstInterval.endTime, 'HHmm');
              const secondStartTime = dayjs(secondInterval.startTime, 'HHmm');
              const secondEndTime = dayjs(secondInterval.endTime, 'HHmm');
              if (firstEndTime.isBefore(secondStartTime) || secondEndTime.isBefore(firstStartTime)) {
                validIntervals = enabledIntervals;
              } else {
                validIntervals.push(firstInterval);
              }
            }

            const enrichedOpeningTime = {...openingTime, validIntervals};

            return enrichedOpeningTime;

          }
      )

    },

    enrichWithDisabledIntervals(enrichedOpeningTimes) {

      return enrichedOpeningTimes?.map(enrichedOpeningTime => {
        const validIntervals = enrichedOpeningTime.validIntervals;//validIntervals:[{startTime: "0800", endTime: "1600"},{startTime: "1800", endTime: "2200"}]
        // valid intervals to disabled intervals

        const disabledIntervals = this.getDisabledIntervalFraValidIntervals(validIntervals);
        return {...enrichedOpeningTime, disabledIntervals} //disabledIntervals format is toDate format
      })
    },


    createMapFromEnrichedOpeningTimes(enrichedOpeningTimes) {
      return enrichedOpeningTimes?.reduce((acc, openingTime) => {
        if (!acc[openingTime.timeType]) {
          acc[openingTime.timeType] = {};
        }
        acc[openingTime.timeType][openingTime.description] = openingTime.disabledIntervals
        return acc;
      }, {});
    },


    getDisabledIntervalsFromOpeningTimes(locationOpeningTimes) {

      const openingTimes = locationOpeningTimes?.openingTimes;

      if (openingTimes?.length === 0) {
        return {}
      }

      const enrichedWithEnabledIntervals = this.enrichEnabledIntervalsBasedOnOpeningsTimes(openingTimes)

      const enrichedWithDisabledIntervals = this.enrichWithDisabledIntervals(enrichedWithEnabledIntervals)

      return this.createMapFromEnrichedOpeningTimes(enrichedWithDisabledIntervals)
    },


    getDisabledIntervalsFromHolidays(locationOpeningTimes) {
      const holidays = locationOpeningTimes?.holidays;
      if (!holidays) {
        return {};
      }
      const holidaysWithDisabledIntervals = holidays.filter(holiday=>!(holiday.startTime[0] == "0000" && holiday.endTime[0] == "0000"))
          .map(holiday => {
            let validIntervals = [];
            validIntervals = [{startTime: holiday.startTime[0], endTime: holiday.endTime[0]}];
            validIntervals = validIntervals.filter(interval => !(interval.startTime == "0001" && interval.endTime == "2359"));// the whole day is closed situation
            const disabledIntervals = this.getDisabledIntervalFraValidIntervals(validIntervals);
            const onlyDate = dayjs(holiday.date).format('YYYY-MM-DD');
            return {...holiday, onlyDate, disabledIntervals};
          })
          .reduce((acc, holiday) => {
            if (!acc[holiday.timeType]) {
              acc[holiday.timeType] = {};
            }
            acc[holiday.timeType][holiday.onlyDate] = holiday.disabledIntervals;
            return acc;
          }, {});

      return holidaysWithDisabledIntervals;
    },

    objectIsEmpty(object) {
      return Object.keys(object).length === 0;
    },


    updateDisabledIntervals: function () {

      this.disabledIntervals = [];
      const updatedDate = this.value; // it is new Date() format

      if (!updatedDate) return;


      let disabledIntervals = []
      const locationOpeningTimes = this.location
      if (locationOpeningTimes?.holidays?.length === 0 && locationOpeningTimes?.openingTimes?.length === 0) {
        const normalValidIntervals = [{startTime: "0600", endTime: "2200"}]
        disabledIntervals = this.getDisabledIntervalFraValidIntervals(normalValidIntervals)

      } else {
        const updatedDateToWeekDay = this.whichWeekDay(updatedDate);
        const disabledIntervalsByWeekday = this.getDisabledIntervalsFromOpeningTimes(locationOpeningTimes)
        const disabledIntervalsByHoliday = this.getDisabledIntervalsFromHolidays(locationOpeningTimes)


        if (this.widgetType === 0 || this.widgetType === 1) {
          if (!this.objectIsEmpty(disabledIntervalsByHoliday)) {
            disabledIntervals = disabledIntervalsByWeekday ? disabledIntervalsByWeekday[this.widgetType][updatedDateToWeekDay] : []

            let updatedDateFormatted = dayjs(updatedDate).format('YYYY-MM-DD');

            let disabledIntervalByHoliday = disabledIntervalsByHoliday[this.widgetType][updatedDateFormatted]
            if (disabledIntervalByHoliday) {
              disabledIntervals = disabledIntervalByHoliday
            }
          } else if (this.objectIsEmpty(disabledIntervalsByHoliday)) {
            disabledIntervals = disabledIntervalsByWeekday ? disabledIntervalsByWeekday[this.widgetType][updatedDateToWeekDay] : []

          }
        }
      }
      this.disabledIntervals = disabledIntervals;

      this.pickerTime.updateOptions({
        restrictions: {
          disabledTimeIntervals: disabledIntervals,
        }
      });

    }
  }
}
</script>

<style lang="scss" scoped>
$fa-font-path: "~@fortawesome/fontawesome-free/webfonts";
@import "./node_modules/@fortawesome/fontawesome-free/scss/fontawesome.scss";
@import "./node_modules/@fortawesome/fontawesome-free/scss/solid.scss";
@import '@eonasdan/tempus-dominus/dist/css/tempus-dominus.css';

.date-time-wrapper {
  position: relative;
}

.time-picker-dropdown {
  position: absolute;
  top: 100%; /* Position it just below the input field */
  left: -100%;
  background: white;
  border: 1px solid #ccc;
  border-radius: 15px;
  max-height: 320px;
  overflow-y: auto;
  width: 200%;
  z-index: 1000;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  box-sizing: border-box;


  //for firefox
  scrollbar-width: thin; /* Makes the scrollbar thinner */
  scrollbar-color: var(--agile-custom05) var(--agile-custom9); /* Thumb color and track color*/
}

//For WebKit browsers (Chrome, Safari)
.time-picker-dropdown::-webkit-scrollbar {
  width: 8px; /* Width of the scrollbar */
}

.time-picker-dropdown::-webkit-scrollbar-track {
  background: var(--agile-custom9); /* Track color */
  border-radius: 10px;
}

.time-picker-dropdown::-webkit-scrollbar-thumb {
  background: var(--agile-custom05); /* Scrollbar color */
  border-radius: 10px;
}

.time-section {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.time-section label {
  font-weight: bold;
}

.time-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.time-button {
  width: 45%; /* Each button will occupy half the width */
  padding: 8px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 400;
}
.btn.custom-button {
  border: 1px solid var(--agile-custom5) !important; /* Blue border */
  color: var(--agile-custom5) !important; /* Blue text */
  background-color: #FFFFFF !important; /* Light blue background */
}
.btn.custom-button:hover {
  background-color: var(--agile-time-border) !important;
  color: #FFFFFF !important;
}
.btn.disabled-button {
  border: 1px solid var(--agile-time-button-disabled-border) !important; /* Gray border */
  color: var(--agile-time-button-disabled-border) !important; /* Light gray text */
  background-color:  #FFFFFF !important; /* Light gray background */
  cursor: not-allowed;
  pointer-events: none;
}


.time-gap {
  height: 10px;
}

.date-time-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

}

.date-time-label {
  color: var(--agile-purple);
  margin-bottom: 4px;
  font-family: "Neue Helvetica",sans-serif;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1em;
}

.date-time-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  border: 1px solid var(--agile-custom4);
  border-radius: 10px 0 0 10px;
  border-right:none;
  min-height:33px;
}
.date-time-row-time {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  border: 1px solid var(--agile-custom4);
  border-radius: 0 10px 10px 0;
  border-left:none;
  min-height:33px;
}

.separated-date-time-symbol {
  margin-right: 5px;
}

.separated-date-input,
.separated-time-input {
  width: 100%;
  background-color: transparent;
  color: var(--agile-purple);
}

.no-gap-form-group ::v-deep {
  legend {
    padding-bottom: 0 !important;
    margin-bottom: 4px;
    color: #00168d;
    font-family: "Neue Helvetica", sans-serif;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1em;
  }
}

.separated-date-time {
  display: flex;
  flex-direction: row;

  border-radius: 10px;
  height: 100%;

}

.separated-date-time-bislet {
  display: flex;
  justify-content: space-evenly;
  border-radius: 10px;
  height: 100%;
  gap: 20px;

}

.date-bislet, .time-bislet {
  width: 50%;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.separated-date-time-symbol {
  //width: 12.5%;
  align-self: center;
  border-radius: 10px 0px 0px 10px;
  text-align: right;
  padding-left: 10px;
  padding-right: 7px;
}

/*
@media screen and (max-width: 471px) {
  .separated-date-time-bislet {
    flex-direction: column;
    align-items: center; !* Optional: Centers items vertically in column mode *!
  }
}
*/

.separated-date-icon {
  color: var(--agile-custom1);

  width: 11px;
  height: 12px;
  //flex: 0 0 20%;
}

.separated-time-icon {
  color: var(--agile-custom1);
  width: 12px;
  height: 12px;
  //flex: 0 0 20%;
}

.separated-date-input {

  border-radius: 0px;
  border: none;
  border-right: 1px solid var(--agile-custom4);
  color: var(--agile-purple);
  padding: 5px 5px 5px 5px;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;

  //flex: 0 0 30%;
  background-color: transparent;
}

.separated-time-input {
  color: var(--agile-purple);
  border-radius: 0px 10px 10px 0px;
  border: none;
  padding: 5px 5px 5px 5px;
  background-color: transparent;
}

.separated-date-input-bislet {
  width: 100%;
  border-radius: 10px;
  border: unset;
  color: var(--agile-custom1);
  padding: 5px 5px 5px 5px;
  height: 58px;

  color: var(--agile-purple);
  /* Text/Text 14 */
  font-family: Helvetica Neue;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
}

.separated-time-input-bislet {

  width: 100%;
  border-radius: 10px;
  border: unset;
  padding: 5px 5px 5px 5px;
  height: 58px;
  /*background-color: transparent;*/

  color: var(--agile-purple);
  /* Text/Text 14 */
  font-family: Helvetica Neue;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
}


</style>
